import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ModelList from "components/ModelList/ModelList";
import NwContent from "components/Layout/NwContent";
import { PackageContextProvider, usePackage } from "contexts/PackageContext";
import NwListLayout from "components/Layout/NwListLayout";



const PackageModelsWrapper = () => {
    const location = useLocation();
    const { code } = useParams();

    return (
        <PackageContextProvider
            packageCode={code}
            pack={location.state}
        >
            <PackageModels />
        </PackageContextProvider>
    );
};

const PackageModels = () => {
    const { currentPack } = usePackage();
    const { code } = useParams();
    const history = useHistory();

    const handleMoveToModel = (model) => {
        history.push({
            pathname: `/ebook/${code}/model/${model.ID}`,
            state: currentPack,
        });
    };

    return (
        currentPack && (
            <NwListLayout>
                <NwContent>
                    <ModelList onModelClick={handleMoveToModel} />
                </NwContent>
            </NwListLayout>
        )
    );
};

export default PackageModelsWrapper;
